import {Monorail} from '@shopify/monorail';
import railsData from 'utilities/rails-data';
import {queryString} from 'utilities/url';
import {getCookieValue, setCookie} from 'utilities/dom/cookies';
import {v4 as uuidV4} from 'uuid';

const MONORAIL_SESSION_KEY = 'monorail_session_token';

interface ExpertsPageViewArgs {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  userToken?: string;
  sessionToken?: string;
  url: string;
  referrer?: string;
  locale?: string;
  shopId?: string;
  deviceType?: string;
  pageIndicator: string;
  serviceHandle?: string;
  rankingPageNumber?: number;
  expertRank?: number;
  partnerId?: string;
}

export interface ExpertsSpecificViewArgs {
  pageIndicator: string;
  serviceHandle?: string;
  rankingPageNumber?: number;
  expertRank?: number;
  partnerId?: string;
}

export const monorail =
  railsData('env') === 'production'
    ? Monorail.createHttpProducer({production: true})
    : Monorail.createLogProducer({debugMode: true});

function logPageView(args: ExpertsPageViewArgs) {
  monorail.produce({
    schemaId: 'experts_marketplace_page_view/1.0',
    payload: args,
  });
}

export function producePageViewMonorailEvent(args: ExpertsSpecificViewArgs) {
  const searchParams = queryString.parse(location.search);

  const defaultArgs = {
    url: location.pathname,
    referrer: document.referrer,
    locale: navigator.language || (navigator.languages || ['en'])[0],
    utmSource: searchParams.utm_source || '',
    utmMedium: searchParams.utm_medium || '',
    utmCampaign: searchParams.utm_campaign || '',
    userToken: '',
    sessionToken: generateSessionCookie(),
  };

  logPageView({...args, ...defaultArgs});
}

function generateSessionCookie(timeInSec = 1800) {
  const existingCookie = getCookieValue(MONORAIL_SESSION_KEY);
  if (existingCookie) return existingCookie;

  const newToken = uuidV4();

  setCookie({
    name: MONORAIL_SESSION_KEY,
    value: newToken,
    expires: timeInSec * 1000,
  });

  return newToken;
}
